import { useTranslation } from 'react-i18next'

import { useListarLeadsRepresados } from '@/features/clientes/hooks/use-listar-leads-represados'
import {
  ResumoDocumentos,
  ResumoDocumentosContent,
  ResumoDocumentosInfo,
} from '@/features/enviar-documentos/components/resumo-documentos'
import { ListaLeadsRepresadosSkeleton } from '@/pages/consulta-leads-represados/ui/lista-leads-represados-skeleton'
import { ApiErrorDisplay } from '@/shared/components/api-error-display'
import { EmptyState } from '@/shared/components/empty-state'
import { Render } from '@/shared/components/render-if'
import { useSearchParamsWithTimestamp } from '@/shared/hooks'
import { StringUtils } from '@/shared/utils'

export const ListaLeadsRepresados = () => {
  const { t } = useTranslation('leads-represados')
  const { filters } = useSearchParamsWithTimestamp()
  const { data: response, isFetching, error, refetch } = useListarLeadsRepresados(filters, true)

  const data = response?.records ?? []

  if (isFetching) return <ListaLeadsRepresadosSkeleton />
  if (error) {
    return (
      <div className="bg-foreground border-muted border">
        <ApiErrorDisplay error={error} resetErrorBoundary={refetch} />
      </div>
    )
  }

  return (
    <div className="bg-foreground divide-y divide-neutral-200 rounded-sm px-6 py-6">
      <Render.If
        condition={!!data.length}
        fallback={
          <EmptyState
            icon="circle-alert"
            iconClassName="text-orange-800 stroke-1"
            title={t('pages.consulta.lista.empty_state.titulo')}
            description={t('pages.consulta.lista.empty_state.descricao')}
          />
        }
      >
        {() => {
          return (
            <>
              <p className="pb-4 text-neutral-600 uppercase">
                {response?.metadata.totalDeItens} {t('pages.consulta.lista.registros_encontrados')}
              </p>
              {data.map((cliente) => (
                <ResumoDocumentos key={cliente.id} to={`/leads-represados/${cliente.id}`}>
                  <ResumoDocumentosContent>
                    <ResumoDocumentosInfo
                      titulo={cliente.nome}
                      descricoes={`${StringUtils.singularPlural(
                        cliente.empreendimentos.length,
                        t('pages.consulta.lista.interesse'),
                        t('pages.consulta.lista.interesses'),
                      )} ${cliente.empreendimentos.join(', ')}`}
                      quantidade={cliente.quantidadeDocumentosEnviados}
                    />
                  </ResumoDocumentosContent>
                </ResumoDocumentos>
              ))}
            </>
          )
        }}
      </Render.If>
    </div>
  )
}
